<!--
 * @Author: vince
 * @Date: 2021-08-18 09:23:11
 * @LastEditors: vince 273187189@qq.com
 * @LastEditTime: 2023-03-12 09:25:15
 * @Description:
-->
<template>
	<el-select size="small" v-if="controlType=='select'" :value="dicTemp" :multiple="multiple" filterable :loading="loading"  placeholder="请选择" value-key="dicCode" clearable @change="change">
		<el-option v-for="item in options" :label="item.dicName" :value="item" :key="item.dicCode"></el-option>
	</el-select>
	<el-checkbox-group v-loading="loading" v-else-if="controlType=='checkbox'" v-model="dicTemp" @change="change">
		<el-checkbox :label="item.dicCode" v-for="item in options" :key="item.dicCode">{{item.dicName}}</el-checkbox>
	</el-checkbox-group>
	<el-radio-group v-else-if="controlType=='radio'" v-model="dicTemp" @change="change">
		<el-radio style="margin-bottom:8px" v-for="item in options" :key="item.dicCode" :label="item.dicCode">{{item.dicName}}</el-radio>
	</el-radio-group>
</template>

<script>
import { mapGetters } from "vuex";
import { getData } from "../../http/fetch.js";

export default {
	name: "dicSelector",
	model: {
		prop: "value",
		event: "change"
	},
	data() {
		return {
			loading: false,
			options: [],
			list: [],
			dicTemp: {
				dicName: "",
				dicCode: ""
			}
		};
	},
	computed: {
		...mapGetters(["schoolCode"])
	},
	props: {
		size:{
			type:String,
			default:'small'
		},
		checkAll: {
			type: Boolean,
			default: false,
		},
		dicType: {
			require: true,
			type: String
		},
		controlType: {
			type: String,
			default: "select"
		},
		value: {
			type: Object | Array
		},
		disabled: {
			type: Boolean,
			default: false
		},
		multiple: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		value: {
			handler(v) {
				if (this.controlType == "checkbox") {
					// console.log("v",v);
					this.dicTemp = v.map(i => i.dicCode);
				} else {
					this.dicTemp = v;
				}
			},
			immediate: true
		}
	},
	created() {
		this.getDictionaryList();
	},
  methods: {
    getNameByCode(code) {
      let find = this.list.find(f => f.dicCode == code);
      if (find) {
        return find.dicName
      } else {
        return code;
      }
    },
		async getDictionaryList() {
			this.loading = true;
			return new Promise((resolve, reject) => {
				getData("/core/dic/getDictionaryList-page", {
					dicType: this.dicType,
					pageNum: 1,
					pageSize: -1
				})
					.then(res => {
						if (res.length > 0) {
							res = res.map(m => {
								return {
									dicCode: m.dicCode,
									dicName: m.dicName
								};
							});
							this.list = res;
							this.$emit("loaded", res);
							this.options = res;
							resolve(res);
						} else {
							this.list = [];
							this.options = [];
							reject();
						}
					})
					.catch(e => {
						reject();
					})
					.finally(() => {
						this.loading = false;
					});
			});
		},
		async remoteMethod(query) {
			if (this.list.length == 0) {
				await this.getDictionaryList();
			}
			if (query != "") {
				this.options = this.list.filter(f => {
					return f.dicName.toLowerCase().indexOf(query.toLowerCase()) > -1;
				});
			} else {
				this.options = this.list;
			}
		},
		change(v) {
			this.dicTemp = v;
			if (this.controlType == "checkbox") {
				this.$emit(
					"change",
					this.options.filter(i => v.includes(i.dicCode))
				);
			} else {
				this.$emit("change", v);
			}
		}
	}
};
</script>

<style>
</style>
